const SPOTIFY_EMBED_URL =
  "https://open.spotify.com/embed/track/3Z6tnMf5j2ijBxju1qv8tU?utm_source=generator";
const APPLE_MUSIC_EMBED_URL =
  "https://embed.music.apple.com/ca/album/relapse/1851809787?i=1851809788";

export function MusicSection() {
  return (
    <section id="music" className="music">
      <h2>Listen to our Music</h2>
      <div className="music-embeds">
        <iframe
          title="Cascade on Spotify"
          src={SPOTIFY_EMBED_URL}
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        />
        <iframe
          title="Cascade on Apple Music"
          src={APPLE_MUSIC_EMBED_URL}
          allow="autoplay *; encrypted-media *;"
          sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
          loading="lazy"
        />
      </div>
    </section>
  );
}
